import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "flowbite";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AppProvider } from "./components/context/appContext";
import CombinedProvider from "./components/context/combinedContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <CombinedProvider>
      <ToastContainer />
      <App />
    </CombinedProvider>
  </React.StrictMode>
);

reportWebVitals();
